import React from 'react';
import {createRoot} from 'react-dom/client';
import {useSHCore} from '@hooks/useSHCore';
import {getInitialMeta, getInitialPageState} from "@helpers/HelperInitialPageState";
import {ContextServicePriceProvider} from "@contexts/ContextServicePriceProvider";
import {ContextCartProvider} from "@contexts/ContextCartProvider";
import {ContextTLDProvider} from "@contexts/ContextTLDProvider";
import {ContextNotificationProvider} from "@contexts/ContextNotificationProvider";
import styles from './PageAboutCompany.scss';
import Header from '@components/base/Header/Header';
import Footer from '@components/base/Footer/Footer';
import AboutCompanyHeaderData from '@components/base/Header/data/AboutCompanyHeaderData';
import ContentA1 from "@components/blocks/ContentA1/ContentA1";
import WhatDoTheNumbersSayData from "@components/blocks/ContentA1/data/WhatDoTheNumbersSayData";
import SomeThingBiggerData from "@components/blocks/ContentA1/data/SomeThingBiggerData";
import ContentA5 from "@components/blocks/ContentA5/ContentA5";
import WhatMakeUsDifferentData from "@components/blocks/ContentA5/data/WhatMakeUsDifferentData";
import ContentA2 from "@components/blocks/ContentA2/ContentA2";
import OurHistoryData from "@components/blocks/ContentA2/data/OurHistoryData";
import ContentD1 from "@components/blocks/ContentD1/ContentD1";
import OurTeamData from "@components/blocks/ContentD1/data/OurTeamData";
import ContentF1 from "@components/blocks/ContentF1/ContentF1";
import SuperHostingInTheMediaData from "@components/blocks/ContentF1/data/SuperHostingInTheMediaData";
import MenuBottom from '@components/base/MenuBottom/MenuBottom';

//////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////

const PageAboutCompany = (props) => {
	useSHCore({props, name: 'PageAboutCompany', isPage: true});

	return (
	  <>
		  <ContextCartProvider>
			  <ContextServicePriceProvider>
				  <ContextTLDProvider>
					  <ContextNotificationProvider color={'color-brand-orange-400'}>
						  <Header data={AboutCompanyHeaderData}/>

						  <main>
							  <ContentA1 data={WhatDoTheNumbersSayData} color={'color-brand-orange-400'}/>
							  <ContentA5 data={WhatMakeUsDifferentData} columns={3} color={'color-brand-orange-400'}/>
							  <ContentF1 data={SuperHostingInTheMediaData} color={'color-brand-orange-400'}/>
							  <ContentA2 data={OurHistoryData} columns={3} color={'color-brand-orange-400'}/>
							  <ContentD1
								data={OurTeamData}
								color={'color-brand-orange-400'}
								blockSize={'800'}
								videoSize={'640'}
							  />
							  <ContentA1 data={SomeThingBiggerData} color={'color-brand-orange-400'}/>

							  <MenuBottom color={'color-brand-orange-400'}/>
						  </main>

						  <Footer color={'color-brand-orange-400'}/>
					  </ContextNotificationProvider>
				  </ContextTLDProvider>
			  </ContextServicePriceProvider>
		  </ContextCartProvider>
	  </>
	)
};

const container = document.getElementById(getInitialMeta('pageAppId'));
const root = createRoot(container);
root.render(<PageAboutCompany data={getInitialPageState()}/>);
